/**
 * Project : workspace
 * File    : PrivacyPolicyScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.common.policy

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier


import component.html.HtmlContent
import component.navigation.TopNavBar
import htmp_page.privacy.PrivacyPolicy
import navigation.AppNavigator

/**
 * Represents the privacy policy screen class.
 */

class PrivacyPolicyScreen {
    @Composable
    fun Content() {
        
        val allPolicies = PrivacyPolicy().getPrivacyPolicy()
        Column(
            modifier = Modifier
                .fillMaxSize()
        ) {
            TopNavBar("Privacy Policy", onBackPress = {
                AppNavigator.shared().goBack()
            })
            LazyColumn(
                modifier = Modifier
                    .fillMaxSize()
            ) {
                items(allPolicies.count()) {
                    HtmlContent(allPolicies[it])
                }
            }
        }
    }
}